import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

// Stanje vozila (Novo/Rabljeno) — vrijednosti prate `condition` filter na API-ju.
export const CONDITION_OPTIONS: DropdownOption[] = [
  { value: "new", text: "Novo" },
  { value: "used", text: "Rabljeno" },
];

// Gorivo — vrijednost je kod (VehicleType.FuelType) koji API filtrira egzaktno.
export const FUEL_OPTIONS: DropdownOption[] = [
  { value: "P", text: "Benzin" },
  { value: "D", text: "Diesel" },
  { value: "E", text: "Električni" },
  { value: "H", text: "Hibrid" },
  { value: "LPG", text: "LPG" },
  { value: "CNG", text: "CNG" },
];

// Kod -> label za prikaz (pokriva i kodove koji nisu u dropdownu, npr. "B" = Benzin).
export const FUEL_LABELS: Record<string, string> = {
  B: "Benzin",
  P: "Benzin",
  D: "Diesel",
  E: "Električni",
  H: "Hibrid",
  LPG: "LPG",
  CNG: "CNG",
};
